import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex, Box, Divider } from 'rebass';
import { T } from 'containers';
import { AppText } from 'domain/appText';

const Wrapper = styled.div`
  background-color: #f5faff;
  border-top: 1px solid #dae6f2;
  border-bottom: 1px solid #dae6f2;
  font-size: 11px;
`;

const FilterLabel = styled.span`
  font-weight: bold;
  font-size: 1.2em;
`;

class FilterControl extends Component {
  static propTypes = {
    middlewares: PropTypes.array,
    filter: PropTypes.string,
    showCategoriesFilter: PropTypes.bool,
  }
  static defaultProps = {
    middlewares: [],
    showCategoriesFilter: true,
  }
  render() {
    const {
      middlewares,
      filter: filtername,
      showCategoriesFilter,
      ...rest
    } = this.props;

    const middlewareProps = middlewarename => ({
      key: filtername + middlewarename,
      middleware: middlewarename,
      filter: filtername,
    });

    const renderMiddlewares = mw =>
      mw.map(({ component, name: middlewarename, defaultValue }) =>
        React.cloneElement(component, {
          ...middlewareProps(middlewarename),
          defaultValue,
        }));

    return (
      <T
        text={[
          AppText.HideGuest,
          AppText.SearchGuest,
          AppText.ShowOnlyAge,
        ]}
        render={([hideGuest, searchGuest, showOnlyAge]) => (
          <Wrapper mx={0} {...rest}>
            <Flex align="center" my={1}>
              <Box w={1 / 3} px={2}><FilterLabel>{hideGuest}</FilterLabel></Box>
              <Box w={2 / 3} pr={2}>
                { renderMiddlewares(middlewares.filter(({ group }) => group === 'hide')) }
              </Box>
            </Flex>
            <Divider color="#dae6f2" />
            {showCategoriesFilter && <Flex align="center" my={1}>
              <Box w={1 / 3} px={2}><FilterLabel>{showOnlyAge}</FilterLabel></Box>
              <Box w={2 / 3} pr={2}>
                { renderMiddlewares(middlewares.filter(({ group }) => group === 'categories')) }
              </Box>
            </Flex>}
            {showCategoriesFilter && <Divider color="#dae6f2" />}
            <Flex align="center" my={1}>
              <Box w={1 / 3} px={2}><FilterLabel>{searchGuest}</FilterLabel></Box>
              <Box w={2 / 3} pr={2}>
                { renderMiddlewares(middlewares.filter(({ group }) => group === 'search')) }
              </Box>
            </Flex>
          </Wrapper>
        )}
      />
    );
  }
}

export default FilterControl;



// WEBPACK FOOTER //
// ./src/components/organisms/FilterControl/index.js